/** @format */

import { Address, Environment } from '@shared/data-access/interfaces';
import {
	AddressAccountSettings,
	AddressRequest,
	AddressRequestV2,
	AddressResponse,
	AddressResponseV2
} from '@my-account/data-access/interfaces';

import { HttpService } from '@shared/data-access/services';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class AddressVerificationService {
	constructor(
		private httpService: HttpService,
		private environment: Environment
	) {}

	public verifyAddress(address: AddressAccountSettings): Observable<AddressResponse> {
		const request: AddressRequest = {
			originIdentifier: 'myaccount-ui',
			unverifiedAddress: address
		};
		return this.httpService.post(
			`${this.environment.baseUrls.addressService}/v1/Address/Verify`,
			request,
			{ useApiAuth: true }
		);
	}

	public verifyAddressV2(address: Address): Observable<AddressResponseV2> {
		const request: AddressRequestV2 = {
			originIdentifier: 'myaccount-ui',
			unverifiedAddress: address
		};
		return this.httpService.post(
			`${this.environment.baseUrls.addressService}/v1/Address/Verify`,
			request
		);
	}
}
